<template>
    <div class="review-pagination">
        <!-- jump to first page -->
        <button v-if="page > 1" @click="changePage(1)">&lt;&lt;</button>
        <!-- previous page -->
        <button v-if="page > 1" @click="changePage(page - 1)">&lt;</button>

        <!-- prev numbered pages -->
        <button v-if="page >= 3" @click="changePage(page - 2)">
            {{ page - 2 }}
        </button>
        <button v-if="page >= 2" @click="changePage(page - 1)">
            {{ page - 1 }}
        </button>

        <!-- current page -->
        <button class="activePage">{{ page }}</button>

        <!-- next numbered pages -->
        <button v-if="numPages - page >= 1" @click="changePage(page + 1)">
            {{ page + 1 }}
        </button>
        <button v-if="numPages - page >= 2" @click="changePage(page + 2)">
            {{ page + 2 }}
        </button>

        <!-- next page -->
        <button v-if="page !== numPages" @click="changePage(page + 1)">
            &gt;
        </button>
        <!-- jump to last page -->
        <button v-if="page !== numPages" @click="changePage(numPages)">
            &gt;&gt;
        </button>
    </div>
</template>

<script src="./ctrl-review-pagination.js"></script>
